<script setup>

import {ErrorMessage, Field, Form} from 'vee-validate'
import {computed, reactive, ref} from 'vue'
import axios from 'axios'
import {useFormSubmit} from '../../composables/useFormSubmit'
import useGlobalStore from '../../store/globalStore'

const schema = {
  first_name: 'required',
  last_name: 'required',
  email: 'required|email',
  phone_number: 'required|phoneNumber',
}

const confirmation = reactive({show: false, message: '', class: ''})
let isSubmitting = ref(false)
const { hideModal, showServerSideValidateErrors, enquirySubmitDataLayer, sendFBLeadData } = useFormSubmit()
const globalStore = useGlobalStore()

const messagePlaceholder = computed(() => {
  if (globalStore.modal.name === 'propertyEnquiryModal') {
    return 'Please email me more information about this property listing.'
  } else if (globalStore.modal.name === 'villageTypesOfHomesModal') {
    return globalStore.modal.descriptionPlaceholder
  }
})

const onSubmit = async () => {
  isSubmitting.value = true
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  const form  = document.getElementById('shareForm');
  let formData = new FormData(form);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    const submitButton = form.querySelector('.submit');
    submitButton.disabled = true;
    formData.set('g-recaptcha-response', token);
    axios.post('/enquiry-submitted', formData).then(function (response) {
      confirmation.class = 'message--success'
      confirmation.message = response.data.msg
      enquirySubmitDataLayer(form);
      sendFBLeadData(formData.get('subject'));
      let currentUrl = window.location.href;
      currentUrl = currentUrl.replace('/info-pack', '');
      currentUrl = currentUrl.replace('#enquiry-submitted', '');
      history.pushState(null, null, `${currentUrl}#enquiry-submitted`);
      hideModal()
    }).catch(error => {
      submitButton.disabled = false;
      showServerSideValidateErrors(error, isSubmitting, confirmation)
    });
  });
}
</script>

<template>
  <Form
    :validation-schema="schema"
    v-slot="{ errors }"
    @submit="onSubmit"
    id="shareForm"
    class="modal-form"
  >
    <slot name="token"></slot>
    <div class="form-group form-group--input">
      <label for="first_name" class="sr-only">First name</label>
      <Field
        id="first_name"
        name="first_name"
        placeholder="First name *"
        class="form-control"
        :class="{'is-danger': errors['first_name'] }"
      />
      <ErrorMessage name="first_name" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="last_name" class="sr-only">Last name</label>
      <Field
        name="last_name"
        placeholder="Last name *"
        class="form-control"
        :class="{'is-danger': errors['last_name'] }"
        tabindex="2"
        id="last_name"
      />
      <ErrorMessage name="last_name" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="email" class="sr-only">Email</label>
      <Field
        tabindex="3"
        id="email"
        name="email"
        placeholder="Email *"
        class="form-control"
        :class="{'is-danger': errors['email'] }"
      />
      <ErrorMessage name="email" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="phone_number" class="sr-only">Phone</label>
      <Field
        tabindex="4"
        id="phone_number"
        name="phone_number"
        placeholder="Phone *"
        class="form-control"
        :class="{'is-danger': errors['phone_number'] }"
      />
      <ErrorMessage name="phone_number" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="message" class="sr-only">Message</label>
      <Field
        as="textarea"
        tabindex="9"
        id="message"
        rows="4"
        :placeholder="messagePlaceholder"
        class="message form-control form-control--textarea"
        name="message"
      ></Field>
    </div>
    <div class="checkbox-custom mt-4 mb-4">
      <input type="checkbox" class="subscribe" id="subscribe_toh" name="subscribe" value="1" checked>
      <label class="form-check-label" for="subscribe_toh">I would like to receive emails with village info, updates and more from Village Guide</label>
    </div>
    <input type="hidden" name="captcha_action" value="village_enquiry">
    <transition name="fade">
      <div :class="confirmation.class" class="message" v-if="confirmation.show">{{ confirmation.message }}</div>
    </transition>
    <slot name="hiddenfields"></slot>
    <div class="form-group mt-5">
      <button type="submit" class="btn btn--green btn--auto-width btn--send submit">
        Send
      </button>
    </div>
    <slot name="googlerecaptchatext"></slot>
  </Form>
</template>
